import React, { FC } from "react";

import classNames from "classnames";

import styles from "./index.module.scss";

interface ReporterDisplayProps {
  reporter?: string;
  company?: string;
}

export const ReporterDisplay: FC<ReporterDisplayProps> = ({ reporter, company }) => {
  const companyNameToDisplay = !company ? <i>No Company</i> : company;
  return (
    <div className={classNames(styles["td-container"])}>
      <div className={classNames(styles["reporter-name"], "b2")}>
        {reporter !== undefined ? reporter : <i>No Reporter</i>}
      </div>
      <p className="mb-0 b4">{companyNameToDisplay}</p>
    </div>
  );
};
